module.exports = __webpack_public_path__ + "img/phone.2291a7d2.svg";